const RELOAD_KEY = 'eventripple:chunk-reload-version'

/** Browser-specific messages for a failed lazy import, not ordinary app errors. */
export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(message)
}

/**
 * React Router catches lazy errors before window events or the outer boundary.
 * Every boundary must use the same persistent guard. Never clear it on mount:
 * the chunk that failed may only be requested after a later navigation.
 */
export function recoverChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error)) return false
  try {
    if (window.sessionStorage.getItem(RELOAD_KEY) === __APP_VERSION__) return false
    window.sessionStorage.setItem(RELOAD_KEY, __APP_VERSION__)
  } catch {
    // Without a persistent guard a broken asset could reload forever. Leave
    // the existing error UI and its manual reload button available instead.
    return false
  }
  window.location.reload()
  return true
}
